'use client';
import { useMemo } from 'react';
import { useTheme, transformExtendedQuery } from '@s7/styles';
import { arrayOf } from '@s7/utils';

var useExtendedQueries = function(queries, units) {
    var theme = useTheme();
    return useMemo(function() {
        return arrayOf(queries).map(function(query) {
            var computedQuery = transformExtendedQuery(query, units, true)(theme);
            if (computedQuery) {
                return computedQuery;
            }
            if (query in theme.breakpoints) {
                return theme.fn.up(query, units, true);
            }
            return query;
        });
    }, [
        queries
    ]);
};

export { useExtendedQueries };
